import axios from "axios"
import { API_BASE_URL } from "../config"

export type PeriodValue = string[] | null

export type SensitivityHistoryItem = {
  id: string
  catv_id?: string | null
  estate_id?: string | null
  facility_id?: string | null
  medical_record_id?: string | null
  medical_record_dynamodb_id?: string | null

  before_sensitivity_enabled?: number | null
  after_sensitivity_enabled?: number | null
  before_sensitivity?: number | null
  after_sensitivity?: number | null

  before_detection_enabled?: number | null
  after_detection_enabled?: number | null
  before_detection_period?: PeriodValue
  after_detection_period?: PeriodValue

  before_option_enabled?: number | null
  after_option_enabled?: number | null
  before_option_period?: PeriodValue
  after_option_period?: PeriodValue

  setting_source_before?: string | null
  setting_source_after?: string | null
  operation_type?: string | null
  user_id?: string | null
  user_type?: string | null
  create_date?: number | null
}

export const getSensitivityHistory = async (
  medicalRecordId: string,
  startDate?: number | null,
  endDate?: number | null
) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/sensitivity_history`, {
        session_code: localStorage.getItem("session_code"),
        medical_record_id: medicalRecordId,
        start_date: startDate || null,
        end_date: endDate || null
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
